/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 40);
/******/ })
/************************************************************************/
/******/ (Array(40).concat([
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(41);

__webpack_require__(56);

__webpack_require__(58);

__webpack_require__(59);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(42);

__webpack_require__(43);

__webpack_require__(44);

__webpack_require__(45);

__webpack_require__(46);

__webpack_require__(47);

__webpack_require__(48);

__webpack_require__(49);

__webpack_require__(50);

__webpack_require__(51);

__webpack_require__(52);

__webpack_require__(53);

__webpack_require__(54);

__webpack_require__(55);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};

	/******/ // The require function
	/******/function __webpack_require__(moduleId) {

		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId])
			/******/return installedModules[moduleId].exports;

		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/exports: {},
			/******/id: moduleId,
			/******/loaded: false
			/******/ };

		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

		/******/ // Flag the module as loaded
		/******/module.loaded = true;

		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}

	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;

	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;

	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "";

	/******/ // Load entry module and return exports
	/******/return __webpack_require__(0);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

	/* global THREE, AFRAME, Element  */
	var cylinderTexture = __webpack_require__(1);
	var parabolicCurve = __webpack_require__(2);
	var RayCurve = __webpack_require__(3);

	if (typeof AFRAME === 'undefined') {
		throw new Error('Component attempted to register before AFRAME was available.');
	}

	if (!Element.prototype.matches) {
		Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
			var matches = (this.document || this.ownerDocument).querySelectorAll(s);
			var i = matches.length;
			while (--i >= 0 && matches.item(i) !== this) {/* no-op */}
			return i > -1;
		};
	}

	AFRAME.registerComponent('teleport-controls', {
		schema: {
			type: { default: 'parabolic', oneOf: ['parabolic', 'line'] },
			button: { default: 'trackpad', oneOf: ['trackpad', 'trigger', 'grip', 'menu'] },
			startEvents: { type: 'array' },
			endEvents: { type: 'array' },
			collisionEntities: { default: '' },
			hitEntity: { type: 'selector' },
			cameraRig: { type: 'selector' },
			teleportOrigin: { type: 'selector' },
			hitCylinderColor: { type: 'color', default: '#99ff99' },
			hitCylinderRadius: { default: 0.25, min: 0 },
			hitCylinderHeight: { default: 0.3, min: 0 },
			maxLength: { default: 10, min: 0, if: { type: ['line'] } },
			curveNumberPoints: { default: 30, min: 2, if: { type: ['parabolic'] } },
			curveLineWidth: { default: 0.025 },
			curveHitColor: { type: 'color', default: '#99ff99' },
			curveMissColor: { type: 'color', default: '#ff0000' },
			curveShootingSpeed: { default: 5, min: 0, if: { type: ['parabolic'] } },
			defaultPlaneSize: { default: 100 },
			landingNormal: { type: 'vec3', default: { x: 0, y: 1, z: 0 } },
			landingMaxAngle: { default: '45', min: 0, max: 360 }
		},

		init: function init() {
			var data = this.data;
			var el = this.el;
			var teleportEntity;
			var i;

			this.active = false;
			this.obj = el.object3D;
			this.hitPoint = new THREE.Vector3();
			this.rigWorldPosition = new THREE.Vector3();
			this.newRigWorldPosition = new THREE.Vector3();
			this.teleportEventDetail = {
				oldPosition: this.rigWorldPosition,
				newPosition: this.newRigWorldPosition,
				hitPoint: this.hitPoint
			};

			this.hit = false;
			this.prevHitHeight = 0;
			this.referenceNormal = new THREE.Vector3();
			this.curveMissColor = new THREE.Color();
			this.curveHitColor = new THREE.Color();
			this.raycaster = new THREE.Raycaster();

			this.defaultPlane = createDefaultPlane(this.data.defaultPlaneSize);

			teleportEntity = this.teleportEntity = document.createElement('a-entity');
			teleportEntity.classList.add('teleportRay');
			teleportEntity.setAttribute('visible', false);
			el.sceneEl.appendChild(this.teleportEntity);

			this.onButtonDown = this.onButtonDown.bind(this);
			this.onButtonUp = this.onButtonUp.bind(this);
			if (this.data.startEvents.length && this.data.endEvents.length) {

				for (i = 0; i < this.data.startEvents.length; i++) {
					el.addEventListener(this.data.startEvents[i], this.onButtonDown);
				}
				for (i = 0; i < this.data.endEvents.length; i++) {
					el.addEventListener(this.data.endEvents[i], this.onButtonUp);
				}
			} else {
				el.addEventListener(data.button + 'down', this.onButtonDown);
				el.addEventListener(data.button + 'up', this.onButtonUp);
			}

			this.queryCollisionEntities();
		},

		update: function update(oldData) {
			var data = this.data;
			var diff = AFRAME.utils.diff(data, oldData);

			// Update normal.
			this.referenceNormal.copy(data.landingNormal);

			// Update colors.
			this.curveMissColor.set(data.curveMissColor);
			this.curveHitColor.set(data.curveHitColor);

			// Create or update line mesh.
			if (!this.line || 'curveLineWidth' in diff || 'curveNumberPoints' in diff || 'type' in diff) {
				this.line = createLine(data);
				this.teleportEntity.setObject3D('mesh', this.line.mesh);
			}

			// Create or update hit entity.
			if (data.hitEntity) {
				this.hitEntity = data.hitEntity;
			} else if (!this.hitEntity || 'hitCylinderColor' in diff || 'hitCylinderHeight' in diff || 'hitCylinderRadius' in diff) {
				// Remove previous entity, create new entity (could be more performant).
				if (this.hitEntity) {
					this.hitEntity.parentNode.removeChild(this.hitEntity);
				}
				this.hitEntity = createHitEntity(data);
				this.el.sceneEl.appendChild(this.hitEntity);
			}
			this.hitEntity.setAttribute('visible', false);

			if ('collisionEntities' in diff) {
				this.queryCollisionEntities();
			}
		},

		remove: function remove() {
			var el = this.el;
			var hitEntity = this.hitEntity;
			var teleportEntity = this.teleportEntity;

			if (hitEntity) {
				hitEntity.parentNode.removeChild(hitEntity);
			}
			if (teleportEntity) {
				teleportEntity.parentNode.removeChild(teleportEntity);
			}

			el.sceneEl.removeEventListener('child-attached', this.childAttachHandler);
			el.sceneEl.removeEventListener('child-detached', this.childDetachHandler);
		},

		tick: function () {
			var p0 = new THREE.Vector3();
			var v0 = new THREE.Vector3();
			var g = -9.8;
			var a = new THREE.Vector3(0, g, 0);
			var next = new THREE.Vector3();
			var last = new THREE.Vector3();
			var quaternion = new THREE.Quaternion();
			var translation = new THREE.Vector3();
			var scale = new THREE.Vector3();
			var shootAngle = new THREE.Vector3();
			var lastNext = new THREE.Vector3();
			var auxDirection = new THREE.Vector3();

			return function (time, delta) {
				if (!this.active) {
					return;
				}

				var matrixWorld = this.obj.matrixWorld;
				matrixWorld.decompose(translation, quaternion, scale);

				var direction = shootAngle.set(0, 0, -1).applyQuaternion(quaternion).normalize();
				this.line.setDirection(auxDirection.copy(direction));
				this.obj.getWorldPosition(p0);

				last.copy(p0);

				// Set default status as non-hit
				this.teleportEntity.setAttribute('visible', true);
				this.line.material.color.set(this.curveMissColor);
				this.hitEntity.setAttribute('visible', false);
				this.hit = false;

				if (this.data.type === 'parabolic') {
					v0.copy(direction).multiplyScalar(this.data.curveShootingSpeed);

					for (var i = 0; i < this.line.numPoints; i++) {
						var t = i / (this.line.numPoints - 1);
						parabolicCurve(p0, v0, a, t, next);
						// Update the raycaster with the length of the current segment last->next
						var dirLastNext = lastNext.copy(next).sub(last).normalize();
						this.raycaster.far = dirLastNext.length();
						this.raycaster.set(last, dirLastNext);

						if (this.checkMeshCollisions(i, next)) {
							break;
						}
						last.copy(next);
					}
				} else if (this.data.type === 'line') {
					next.copy(last).add(auxDirection.copy(direction).multiplyScalar(this.data.maxLength));
					this.raycaster.far = this.data.maxLength;
					this.raycaster.set(p0, direction);
					this.line.setPoint(0, p0);

					this.checkMeshCollisions(1, next);
				}
			};
		}(),

		/**
   * Run `querySelectorAll` for `collisionEntities` and maintain it with `child-attached`
   * and `child-detached` events.
   */
		queryCollisionEntities: function queryCollisionEntities() {
			var collisionEntities;
			var data = this.data;
			var el = this.el;

			if (!data.collisionEntities) {
				this.collisionEntities = [];
				return;
			}

			collisionEntities = [].slice.call(el.sceneEl.querySelectorAll(data.collisionEntities));
			this.collisionEntities = collisionEntities;

			// Update entity list on attach.
			this.childAttachHandler = function childAttachHandler(evt) {
				if (!evt.detail.el.matches(data.collisionEntities)) {
					return;
				}
				collisionEntities.push(evt.detail.el);
			};
			el.sceneEl.addEventListener('child-attached', this.childAttachHandler);

			// Update entity list on detach.
			this.childDetachHandler = function childDetachHandler(evt) {
				var index;
				if (!evt.detail.el.matches(data.collisionEntities)) {
					return;
				}
				index = collisionEntities.indexOf(evt.detail.el);
				if (index === -1) {
					return;
				}
				collisionEntities.splice(index, 1);
			};
			el.sceneEl.addEventListener('child-detached', this.childDetachHandler);
		},

		onButtonDown: function onButtonDown() {
			this.active = true;
		},

		/**
   * Jump!
   */
		onButtonUp: function () {
			var teleportOriginWorldPosition = new THREE.Vector3();
			var newRigLocalPosition = new THREE.Vector3();
			var newHandPosition = [new THREE.Vector3(), new THREE.Vector3()]; // Left and right
			var handPosition = new THREE.Vector3();

			return function (evt) {
				if (!this.active) {
					return;
				}

				// Hide the hit point and the curve
				this.active = false;
				this.hitEntity.setAttribute('visible', false);
				this.teleportEntity.setAttribute('visible', false);

				if (!this.hit) {
					// Button released but not hit point
					return;
				}

				var rig = this.data.cameraRig || this.el.sceneEl.camera.el;
				rig.object3D.getWorldPosition(this.rigWorldPosition);
				this.newRigWorldPosition.copy(this.hitPoint);

				// If a teleportOrigin exists, offset the rig such that the teleportOrigin is above the hitPoint
				var teleportOrigin = this.data.teleportOrigin;
				if (teleportOrigin) {
					teleportOrigin.object3D.getWorldPosition(teleportOriginWorldPosition);
					this.newRigWorldPosition.sub(teleportOriginWorldPosition).add(this.rigWorldPosition);
				}

				// Always keep the rig at the same offset off the ground after teleporting
				this.newRigWorldPosition.y = this.rigWorldPosition.y + this.hitPoint.y - this.prevHitHeight;
				this.prevHitHeight = this.hitPoint.y;

				// Finally update the rigs position
				newRigLocalPosition.copy(this.newRigWorldPosition);
				if (rig.object3D.parent) {
					rig.object3D.parent.worldToLocal(newRigLocalPosition);
				}
				rig.setAttribute('position', newRigLocalPosition);

				// If a rig was not explicitly declared, look for hands and mvoe them proportionally as well
				if (!this.data.cameraRig) {
					var hands = document.querySelectorAll('a-entity[tracked-controls]');
					for (var i = 0; i < hands.length; i++) {
						hands[i].object3D.getWorldPosition(handPosition);

						// diff = rigWorldPosition - handPosition
						// newPos = newRigWorldPosition - diff
						newHandPosition[i].copy(this.newRigWorldPosition).sub(this.rigWorldPosition).add(handPosition);
						hands[i].setAttribute('position', newHandPosition[i]);
					}
				}

				this.el.emit('teleported', this.teleportEventDetail);
			};
		}(),

		/**
   * Check for raycaster intersection.
   *
   * @param {number} Line fragment point index.
   * @param {number} Next line fragment point index.
   * @returns {boolean} true if there's an intersection.
   */
		checkMeshCollisions: function checkMeshCollisions(i, next) {
			// @todo We should add a property to define if the collisionEntity is dynamic or static
			// If static we should do the map just once, otherwise we're recreating the array in every
			// loop when aiming.
			var meshes = this.collisionEntities.map(function (entity) {
				return entity.getObject3D('mesh');
			}).filter(function (n) {
				return n;
			});
			meshes = meshes.length ? meshes : [this.defaultPlane];

			var intersects = this.raycaster.intersectObjects(meshes, true);
			if (intersects.length > 0 && !this.hit && this.isValidNormalsAngle(intersects[0].face.normal)) {
				var point = intersects[0].point;

				this.line.material.color.set(this.curveHitColor);
				this.hitEntity.setAttribute('position', point);
				this.hitEntity.setAttribute('visible', true);

				this.hit = true;
				this.hitPoint.copy(intersects[0].point);

				// If hit, just fill the rest of the points with the hit point and break the loop
				for (var j = i; j < this.line.numPoints; j++) {
					this.line.setPoint(j, this.hitPoint);
				}
				return true;
			} else {
				this.line.setPoint(i, next);
				return false;
			}
		},

		isValidNormalsAngle: function isValidNormalsAngle(collisionNormal) {
			var angleNormals = this.referenceNormal.angleTo(collisionNormal);
			return THREE.Math.RAD2DEG * angleNormals <= this.data.landingMaxAngle;
		}
	});

	function createLine(data) {
		var numPoints = data.type === 'line' ? 2 : data.curveNumberPoints;
		return new RayCurve(numPoints, data.curveLineWidth);
	}

	/**
  * Create mesh to represent the area of intersection.
  * Default to a combination of torus and cylinder.
  */
	function createHitEntity(data) {
		var cylinder;
		var hitEntity;
		var torus;

		// Parent.
		hitEntity = document.createElement('a-entity');
		hitEntity.className = 'hitEntity';

		// Torus.
		torus = document.createElement('a-entity');
		torus.setAttribute('geometry', {
			primitive: 'torus',
			radius: data.hitCylinderRadius,
			radiusTubular: 0.01
		});
		torus.setAttribute('rotation', { x: 90, y: 0, z: 0 });
		torus.setAttribute('material', {
			shader: 'flat',
			color: data.hitCylinderColor,
			side: 'double',
			depthTest: false
		});
		hitEntity.appendChild(torus);

		// Cylinder.
		cylinder = document.createElement('a-entity');
		cylinder.setAttribute('position', { x: 0, y: data.hitCylinderHeight / 2, z: 0 });
		cylinder.setAttribute('geometry', {
			primitive: 'cylinder',
			segmentsHeight: 1,
			radius: data.hitCylinderRadius,
			height: data.hitCylinderHeight,
			openEnded: true
		});
		cylinder.setAttribute('material', {
			shader: 'flat',
			color: data.hitCylinderColor,
			side: 'double',
			src: cylinderTexture,
			transparent: true,
			depthTest: false
		});
		hitEntity.appendChild(cylinder);

		return hitEntity;
	}

	function createDefaultPlane(size) {
		var geometry;
		var material;

		geometry = new THREE.PlaneBufferGeometry(100, 100);
		geometry.rotateX(-Math.PI / 2);
		material = new THREE.MeshBasicMaterial({ color: 0xffff00 });
		return new THREE.Mesh(geometry, material);
	}

	/***/
},
/* 1 */
/***/function (module, exports) {

	module.exports = 'url(data:image/png;base64,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)';

	/***/
},
/* 2 */
/***/function (module, exports) {

	/* global THREE */
	// Parabolic motion equation, y = p0 + v0*t + 1/2at^2
	function parabolicCurveScalar(p0, v0, a, t) {
		return p0 + v0 * t + 0.5 * a * t * t;
	}

	// Parabolic motion equation applied to 3 dimensions
	function parabolicCurve(p0, v0, a, t, out) {
		out.x = parabolicCurveScalar(p0.x, v0.x, a.x, t);
		out.y = parabolicCurveScalar(p0.y, v0.y, a.y, t);
		out.z = parabolicCurveScalar(p0.z, v0.z, a.z, t);
		return out;
	}

	module.exports = parabolicCurve;

	/***/
},
/* 3 */
/***/function (module, exports) {

	/* global THREE */
	var RayCurve = function RayCurve(numPoints, width) {
		this.geometry = new THREE.BufferGeometry();
		this.vertices = new Float32Array(numPoints * 3 * 2);
		this.uvs = new Float32Array(numPoints * 2 * 2);
		this.width = width;

		this.geometry.addAttribute('position', new THREE.BufferAttribute(this.vertices, 3).setDynamic(true));

		this.material = new THREE.MeshBasicMaterial({
			side: THREE.DoubleSide,
			color: 0xff0000
		});

		this.mesh = new THREE.Mesh(this.geometry, this.material);
		this.mesh.drawMode = THREE.TriangleStripDrawMode;

		this.mesh.frustumCulled = false;
		this.mesh.vertices = this.vertices;

		this.direction = new THREE.Vector3();
		this.numPoints = numPoints;
	};

	RayCurve.prototype = {
		setDirection: function setDirection(direction) {
			var UP = new THREE.Vector3(0, 1, 0);
			this.direction.copy(direction).cross(UP).normalize().multiplyScalar(this.width / 2);
		},

		setWidth: function setWidth(width) {
			this.width = width;
		},

		setPoint: function () {
			var posA = new THREE.Vector3();
			var posB = new THREE.Vector3();

			return function (i, point) {
				posA.copy(point).add(this.direction);
				posB.copy(point).sub(this.direction);

				var idx = 2 * 3 * i;
				this.vertices[idx++] = posA.x;
				this.vertices[idx++] = posA.y;
				this.vertices[idx++] = posA.z;

				this.vertices[idx++] = posB.x;
				this.vertices[idx++] = posB.y;
				this.vertices[idx++] = posB.z;

				this.geometry.attributes.position.needsUpdate = true;
			};
		}()
	};

	module.exports = RayCurve;

	/***/
}]
/******/);

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t) {
  function e(n) {
    if (o[n]) return o[n].exports;var r = o[n] = { i: n, l: !1, exports: {} };return t[n].call(r.exports, r, r.exports, e), r.l = !0, r.exports;
  }var o = {};return e.m = t, e.c = o, e.i = function (t) {
    return t;
  }, e.d = function (t, o, n) {
    e.o(t, o) || Object.defineProperty(t, o, { configurable: !1, enumerable: !0, get: n });
  }, e.n = function (t) {
    var o = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return e.d(o, "a", o), o;
  }, e.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, e.p = "", e(e.s = 0);
}([function (t, e) {
  var o = AFRAME.utils.debug,
      n = AFRAME.utils.coordinates,
      r = o("components:look-at:warn"),
      i = n.isCoordinates;delete AFRAME.components["look-at"], AFRAME.registerComponent("look-at", { schema: { default: "", parse: function parse(t) {
        return i(t) || "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? n.parse(t) : t;
      }, stringify: function stringify(t) {
        return "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) ? n.stringify(t) : t;
      } }, init: function init() {
      this.target3D = null, this.vector = new THREE.Vector3();
    }, update: function update() {
      var t,
          e = this,
          o = e.data,
          n = e.el.object3D;return !o || "object" == (typeof o === "undefined" ? "undefined" : _typeof(o)) && !Object.keys(o).length ? e.remove() : "object" == (typeof o === "undefined" ? "undefined" : _typeof(o)) ? n.lookAt(new THREE.Vector3(o.x, o.y, o.z)) : (t = e.el.sceneEl.querySelector(o), t ? t.hasLoaded ? e.beginTracking(t) : t.addEventListener("loaded", function () {
        e.beginTracking(t);
      }) : void r('"' + o + '" does not point to a valid entity to look-at'));
    }, tick: function tick(t) {
      var e = this.target3D;if (e) return this.el.object3D.lookAt(this.vector.setFromMatrixPosition(e.matrixWorld));
    }, beginTracking: function beginTracking(t) {
      this.target3D = t.object3D;
    } });
}]);

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/******/(function (modules) {
	// webpackBootstrap
	/******/ // The module cache
	/******/var installedModules = {};

	/******/ // The require function
	/******/function __webpack_require__(moduleId) {

		/******/ // Check if module is in cache
		/******/if (installedModules[moduleId])
			/******/return installedModules[moduleId].exports;

		/******/ // Create a new module (and put it into the cache)
		/******/var module = installedModules[moduleId] = {
			/******/exports: {},
			/******/id: moduleId,
			/******/loaded: false
			/******/ };

		/******/ // Execute the module function
		/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

		/******/ // Flag the module as loaded
		/******/module.loaded = true;

		/******/ // Return the exports of the module
		/******/return module.exports;
		/******/
	}

	/******/ // expose the modules object (__webpack_modules__)
	/******/__webpack_require__.m = modules;

	/******/ // expose the module cache
	/******/__webpack_require__.c = installedModules;

	/******/ // __webpack_public_path__
	/******/__webpack_require__.p = "";

	/******/ // Load entry module and return exports
	/******/return __webpack_require__(0);
	/******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
		return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	} : function (obj) {
		return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
	};

	var _gifsparser = __webpack_require__(1);

	if (typeof AFRAME === 'undefined') {
		throw 'Component attempted to register before AFRAME was available.';
	}

	/* get util from AFRAME */
	var parseUrl = AFRAME.utils.srcLoader.parseUrl;
	var debug = AFRAME.utils.debug;
	// debug.enable('shader:gif:*')

	debug.enable('shader:gif:warn');
	var warn = debug('shader:gif:warn');
	var log = debug('shader:gif:debug');

	/* store data so that you won't load same data */
	var gifData = {};

	/* create error message */
	function createError(err, src) {
		return { status: 'error', src: src, message: err, timestamp: Date.now() };
	}

	AFRAME.registerShader('gif', {

		/**
   * For material component:
   * @see https://github.com/aframevr/aframe/blob/60d198ef8e2bfbc57a13511ae5fca7b62e01691b/src/components/material.js
   * For example of `registerShader`:
   * @see https://github.com/aframevr/aframe/blob/41a50cd5ac65e462120ecc2e5091f5daefe3bd1e/src/shaders/flat.js
   * For MeshBasicMaterial
   * @see http://threejs.org/docs/#Reference/Materials/MeshBasicMaterial
   */

		schema: {

			/* For material */
			color: { type: 'color' },
			fog: { default: true },

			/* For texuture */
			src: { default: null },
			autoplay: { default: true }

		},

		/**
   * Initialize material. Called once.
   * @protected
   */
		init: function init(data) {
			log('init', data);
			log(this.el.components);
			this.__cnv = document.createElement('canvas');
			this.__cnv.width = 2;
			this.__cnv.height = 2;
			this.__ctx = this.__cnv.getContext('2d');
			this.__texture = new THREE.Texture(this.__cnv); //renders straight from a canvas
			this.__material = {};
			this.__reset();
			this.material = new THREE.MeshBasicMaterial({ map: this.__texture });
			this.el.sceneEl.addBehavior(this);
			this.__addPublicFunctions();
			return this.material;
		},

		/**
   * Update or create material.
   * @param {object|null} oldData
   */
		update: function update(oldData) {
			log('update', oldData);
			this.__updateMaterial(oldData);
			this.__updateTexture(oldData);
			return this.material;
		},

		/**
   * Called on each scene tick.
   * @protected
   */
		tick: function tick(t) {
			if (!this.__frames || this.paused()) return;
			if (Date.now() - this.__startTime >= this.__nextFrameTime) {
				this.nextFrame();
			}
		},

		/*================================
  =            material            =
  ================================*/

		/**
   * Updating existing material.
   * @param {object} data - Material component data.
   */
		__updateMaterial: function __updateMaterial(data) {
			var material = this.material;

			var newData = this.__getMaterialData(data);
			Object.keys(newData).forEach(function (key) {
				material[key] = newData[key];
			});
		},

		/**
   * Builds and normalize material data, normalizing stuff along the way.
   * @param {Object} data - Material data.
   * @return {Object} data - Processed material data.
   */
		__getMaterialData: function __getMaterialData(data) {
			return {
				fog: data.fog,
				color: new THREE.Color(data.color)
			};
		},

		/*==============================
  =            texure            =
  ==============================*/

		/**
   * set texure
   * @private
   * @param {Object} data
   * @property {string} status - success / error
   * @property {string} src - src url
   * @property {array} times - array of time length of each image
   * @property {number} cnt - total counts of gif images
   * @property {array} frames - array of each image
   * @property {Date} timestamp - created at the texure
   */

		__setTexure: function __setTexure(data) {
			log('__setTexure', data);
			if (data.status === 'error') {
				warn('Error: ' + data.message + '\nsrc: ' + data.src);
				this.__reset();
			} else if (data.status === 'success' && data.src !== this.__textureSrc) {
				this.__reset();
				/* Texture added or changed */
				this.__ready(data);
			}
		},

		/**
   * Update or create texure.
   * @param {Object} data - Material component data.
   */
		__updateTexture: function __updateTexture(data) {
			var src = data.src;
			var autoplay = data.autoplay;

			/* autoplay */

			if (typeof autoplay === 'boolean') {
				this.__autoplay = autoplay;
			} else if (typeof autoplay === 'undefined') {
				this.__autoplay = true;
			}
			if (this.__autoplay && this.__frames) {
				this.play();
			}

			/* src */
			if (src) {
				this.__validateSrc(src, this.__setTexure.bind(this));
			} else {
				/* Texture removed */
				this.__reset();
			}
		},

		/*=============================================
  =            varidation for texure            =
  =============================================*/

		__validateSrc: function __validateSrc(src, cb) {

			/* check if src is a url */
			var url = parseUrl(src);
			if (url) {
				this.__getImageSrc(url, cb);
				return;
			}

			var message = void 0;

			/* check if src is a query selector */
			var el = this.__validateAndGetQuerySelector(src);
			if (!el || (typeof el === 'undefined' ? 'undefined' : _typeof(el)) !== 'object') {
				return;
			}
			if (el.error) {
				message = el.error;
			} else {
				var tagName = el.tagName.toLowerCase();
				if (tagName === 'video') {
					src = el.src;
					message = 'For video, please use `aframe-video-shader`';
				} else if (tagName === 'img') {
					this.__getImageSrc(el.src, cb);
					return;
				} else {
					message = 'For <' + tagName + '> element, please use `aframe-html-shader`';
				}
			}

			/* if there is message, create error data */
			if (message) {
				(function () {
					var srcData = gifData[src];
					var errData = createError(message, src);
					/* callbacks */
					if (srcData && srcData.callbacks) {
						srcData.callbacks.forEach(function (cb) {
							return cb(errData);
						});
					} else {
						cb(errData);
					}
					/* overwrite */
					gifData[src] = errData;
				})();
			}
		},

		/**
   * Validate src is a valid image url
   * @param  {string} src - url that will be tested
   * @param  {function} cb - callback with the test result
   */
		__getImageSrc: function __getImageSrc(src, cb) {
			var _this = this;

			/* if src is same as previous, ignore this */
			if (src === this.__textureSrc) {
				return;
			}

			/* check if we already get the srcData */
			var srcData = gifData[src];
			if (!srcData || !srcData.callbacks) {
				/* create callback */
				srcData = gifData[src] = { callbacks: [] };
				srcData.callbacks.push(cb);
			} else if (srcData.src) {
				cb(srcData);
				return;
			} else if (srcData.callbacks) {
				/* add callback */
				srcData.callbacks.push(cb);
				return;
			}
			var tester = new Image();
			tester.crossOrigin = 'Anonymous';
			tester.addEventListener('load', function (e) {
				/* check if it is gif */
				_this.__getUnit8Array(src, function (arr) {
					if (!arr) {
						onError('This is not gif. Please use `shader:flat` instead');
						return;
					}
					/* parse data */
					(0, _gifsparser.parseGIF)(arr, function (times, cnt, frames) {
						/* store data */
						var newData = { status: 'success', src: src, times: times, cnt: cnt, frames: frames, timestamp: Date.now() };
						/* callbacks */
						if (srcData.callbacks) {
							srcData.callbacks.forEach(function (cb) {
								return cb(newData);
							});
							/* overwrite */
							gifData[src] = newData;
						}
					}, function (err) {
						return onError(err);
					});
				});
			});
			tester.addEventListener('error', function (e) {
				return onError('Could be the following issue\n - Not Image\n - Not Found\n - Server Error\n - Cross-Origin Issue');
			});
			function onError(message) {
				/* create error data */
				var errData = createError(message, src);
				/* callbacks */
				if (srcData.callbacks) {
					srcData.callbacks.forEach(function (cb) {
						return cb(errData);
					});
					/* overwrite */
					gifData[src] = errData;
				}
			}
			tester.src = src;
		},

		/**
   *
   * get mine type
   *
   */
		__getUnit8Array: function __getUnit8Array(src, cb) {
			if (typeof cb !== 'function') {
				return;
			}

			var xhr = new XMLHttpRequest();
			xhr.open('GET', src);
			xhr.responseType = 'arraybuffer';
			xhr.addEventListener('load', function (e) {
				var uint8Array = new Uint8Array(e.target.response);
				var arr = uint8Array.subarray(0, 4);
				// const header = arr.map(value => value.toString(16)).join('')
				var header = '';
				for (var i = 0; i < arr.length; i++) {
					header += arr[i].toString(16);
				}
				if (header === '47494638') {
					cb(uint8Array);
				} else {
					cb();
				}
			});
			xhr.addEventListener('error', function (e) {
				log(e);
				cb();
			});
			xhr.send();
		},

		/**
   * Query and validate a query selector,
   *
   * @param  {string} selector - DOM selector.
   * @return {object} Selected DOM element | error message object.
   */
		__validateAndGetQuerySelector: function __validateAndGetQuerySelector(selector) {
			try {
				var el = document.querySelector(selector);
				if (!el) {
					return { error: 'No element was found matching the selector' };
				}
				return el;
			} catch (e) {
				// Capture exception if it's not a valid selector.
				return { error: 'no valid selector' };
			}
		},

		/*================================
  =            playback            =
  ================================*/

		/**
   * add public functions
   * @private
   */
		__addPublicFunctions: function __addPublicFunctions() {
			this.el.gif = {
				play: this.play.bind(this),
				pause: this.pause.bind(this),
				togglePlayback: this.togglePlayback.bind(this),
				paused: this.paused.bind(this),
				nextFrame: this.nextFrame.bind(this)
			};
		},

		/**
   * Pause gif
   * @public
   */
		pause: function pause() {
			log('pause');
			this.__paused = true;
		},

		/**
   * Play gif
   * @public
   */
		play: function play() {
			log('play');
			this.__paused = false;
		},

		/**
   * Toggle playback. play if paused and pause if played.
   * @public
   */

		togglePlayback: function togglePlayback() {

			if (this.paused()) {
				this.play();
			} else {
				this.pause();
			}
		},

		/**
   * Return if the playback is paused.
   * @public
   * @return {boolean}
   */
		paused: function paused() {
			return this.__paused;
		},

		/**
   * Go to next frame
   * @public
   */
		nextFrame: function nextFrame() {
			this.__draw();

			/* update next frame time */
			while (Date.now() - this.__startTime >= this.__nextFrameTime) {

				this.__nextFrameTime += this.__delayTimes[this.__frameIdx++];
				if ((this.__infinity || this.__loopCnt) && this.__frameCnt <= this.__frameIdx) {
					/* go back to the first */
					this.__frameIdx = 0;
				}
			}
		},

		/*==============================
   =            canvas            =
   ==============================*/

		/**
   * clear canvas
   * @private
   */
		__clearCanvas: function __clearCanvas() {
			this.__ctx.clearRect(0, 0, this.__width, this.__height);
			this.__texture.needsUpdate = true;
		},

		/**
   * draw
   * @private
   */
		__draw: function __draw() {
			this.__ctx.drawImage(this.__frames[this.__frameIdx], 0, 0, this.__width, this.__height);
			this.__texture.needsUpdate = true;
		},

		/*============================
  =            ready            =
  ============================*/

		/**
   * setup gif animation and play if autoplay is true
   * @private
   * @property {string} src - src url
   * @param {array} times - array of time length of each image
   * @param {number} cnt - total counts of gif images
   * @param {array} frames - array of each image
   */
		__ready: function __ready(_ref) {
			var src = _ref.src;
			var times = _ref.times;
			var cnt = _ref.cnt;
			var frames = _ref.frames;

			log('__ready');
			this.__textureSrc = src;
			this.__delayTimes = times;
			cnt ? this.__loopCnt = cnt : this.__infinity = true;
			this.__frames = frames;
			this.__frameCnt = times.length;
			this.__startTime = Date.now();
			this.__width = THREE.Math.nearestPowerOfTwo(frames[0].width);
			this.__height = THREE.Math.nearestPowerOfTwo(frames[0].height);
			this.__cnv.width = this.__width;
			this.__cnv.height = this.__height;
			this.__draw();
			if (this.__autoplay) {
				this.play();
			} else {
				this.pause();
			}
		},

		/*=============================
  =            reset            =
  =============================*/

		/**
   * @private
   */

		__reset: function __reset() {
			this.pause();
			this.__clearCanvas();
			this.__startTime = 0;
			this.__nextFrameTime = 0;
			this.__frameIdx = 0;
			this.__frameCnt = 0;
			this.__delayTimes = null;
			this.__infinity = false;
			this.__loopCnt = 0;
			this.__frames = null;
			this.__textureSrc = null;
		}
	});

	/***/
},
/* 1 */
/***/function (module, exports) {

	'use strict';

	/**
  * 
  * Gif parser by @gtk2k
  * https://github.com/gtk2k/gtk2k.github.io/tree/master/animation_gif
  *
  */

	exports.parseGIF = function (gif, successCB, errorCB) {

		var pos = 0;
		var delayTimes = [];
		var loadCnt = 0;
		var graphicControl = null;
		var imageData = null;
		var frames = [];
		var loopCnt = 0;

		if (gif[0] === 0x47 && gif[1] === 0x49 && gif[2] === 0x46 && // 'GIF'
		gif[3] === 0x38 && (gif[4] === 0x39 || gif[4] === 0x37) && gif[5] === 0x61) {
			// '89a'
			//	  gif[3] === 0x38 && gif[4] === 0x39 && gif[5] === 0x61) {
			// '89a'
			pos += 13 + +!!(gif[10] & 0x80) * Math.pow(2, (gif[10] & 0x07) + 1) * 3;
			var gifHeader = gif.subarray(0, pos);
			while (gif[pos] && gif[pos] !== 0x3b) {
				var offset = pos,
				    blockId = gif[pos];
				if (blockId === 0x21) {
					var label = gif[++pos];
					if ([0x01, 0xfe, 0xf9, 0xff].indexOf(label) !== -1) {
						label === 0xf9 && delayTimes.push((gif[pos + 3] + (gif[pos + 4] << 8)) * 10);
						label === 0xff && (loopCnt = gif[pos + 15] + (gif[pos + 16] << 8));
						while (gif[++pos]) {
							pos += gif[pos];
						}label === 0xf9 && (graphicControl = gif.subarray(offset, pos + 1));
					} else {
						errorCB && errorCB('parseGIF: unknown label');break;
					}
				} else if (blockId === 0x2c) {
					pos += 9;
					pos += 1 + +!!(gif[pos] & 0x80) * (Math.pow(2, (gif[pos] & 0x07) + 1) * 3);
					while (gif[++pos]) {
						pos += gif[pos];
					}var imageData = gif.subarray(offset, pos + 1);
					frames.push(URL.createObjectURL(new Blob([gifHeader, graphicControl, imageData])));
				} else {
					errorCB && errorCB('parseGIF: unknown blockId');break;
				}
				pos++;
			}
		} else {
			errorCB && errorCB('parseGIF: no GIF89a');
		}
		if (frames.length) {

			var cnv = document.createElement('canvas');
			var loadImg = function loadImg() {
				frames.forEach(function (src, i) {
					var img = new Image();
					img.onload = function (e, i) {
						if (i === 0) {
							cnv.width = img.width;
							cnv.height = img.height;
						}
						loadCnt++;
						frames[i] = this;
						if (loadCnt === frames.length) {
							loadCnt = 0;
							imageFix(1);
						}
					}.bind(img, null, i);
					img.src = src;
				});
			};
			var imageFix = function imageFix(i) {
				var img = new Image();
				img.onload = function (e, i) {
					loadCnt++;
					frames[i] = this;
					if (loadCnt === frames.length) {
						cnv = null;
						successCB && successCB(delayTimes, loopCnt, frames);
					} else {
						imageFix(++i);
					}
				}.bind(img);
				img.src = cnv.toDataURL('image/gif');
			};
			loadImg();
		}
	};

	/***/
}
/******/]);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


!function (t) {
  function e(r) {
    if (n[r]) return n[r].exports;var i = n[r] = { exports: {}, id: r, loaded: !1 };return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
  }var n = {};return e.m = t, e.c = n, e.p = "", e(0);
}([function (t, e, n) {
  function r(t, e) {
    var n, r, i, a;return i = e.split("."), r = i[0], a = i[1], n = t.components[r] || AFRAME.components[r], n ? a && !n.schema[a] ? null : a ? n.schema[a].type : n.schema.type : null;
  }function i(t) {
    t.x = THREE.Math.degToRad(t.x), t.y = THREE.Math.degToRad(t.y), t.z = THREE.Math.degToRad(t.z);
  }function a(t, e, n) {
    var r;for (r = 0; r < e.length; r++) {
      t.addEventListener(e[r], n);
    }
  }function o(t, e, n) {
    var r;for (r = 0; r < e.length; r++) {
      t.removeEventListener(e[r], n);
    }
  }function s(t, e) {
    var n, r, i;for (r = f(e), i = t, n = 0; n < r.length; n++) {
      i = i[r[n]];
    }return i;
  }function u(t, e, n, r) {
    var i, a, o, s;for (a = f(e), s = t, i = 0; i < a.length - 1; i++) {
      s = s[a[i]];
    }return o = a[a.length - 1], r === v ? void ("r" in s[o] ? (s[o].r = n.r, s[o].g = n.g, s[o].b = n.b) : (s[o].x = n.r, s[o].y = n.g, s[o].z = n.b)) : void (s[o] = n);
  }function f(t) {
    return t in g ? g[t] : (g[t] = t.split("."), g[t]);
  }function l(t) {
    return t.isRawProperty || t.property.startsWith(E) || t.property.startsWith(w);
  }var c = n(1);if (AFRAME.anime = c, "undefined" == typeof AFRAME) throw new Error("Component attempted to register before AFRAME was available.");var p = new THREE.Color(),
      d = new THREE.Color(),
      h = AFRAME.utils,
      m = h.entity.getComponentProperty,
      y = h.entity.setComponentProperty,
      g = {},
      v = "color",
      b = "position",
      A = "rotation",
      x = "scale",
      E = "components",
      w = "object3D";AFRAME.registerComponent("animation", { schema: { autoplay: { default: !0 }, delay: { default: 0 }, dir: { default: "" }, dur: { default: 1e3 }, easing: { default: "easeInQuad" }, elasticity: { default: 400 }, from: { default: "" }, loop: { default: 0, parse: function parse(t) {
          return t === !0 || "true" === t || t !== !1 && "false" !== t && parseInt(t, 10);
        } }, property: { default: "" }, startEvents: { type: "array" }, pauseEvents: { type: "array" }, resumeEvents: { type: "array" }, to: { default: "" }, type: { default: "" }, isRawProperty: { default: !1 } }, multiple: !0, init: function init() {
      var t = this;this.eventDetail = { name: this.attrName }, this.time = 0, this.animation = null, this.animationIsPlaying = !1, this.onStartEvent = this.onStartEvent.bind(this), this.beginAnimation = this.beginAnimation.bind(this), this.pauseAnimation = this.pauseAnimation.bind(this), this.resumeAnimation = this.resumeAnimation.bind(this), this.fromColor = {}, this.toColor = {}, this.targets = {}, this.targetsArray = [], this.config = { complete: function complete() {
          t.animationIsPlaying = !1, t.el.emit("animationcomplete", t.eventDetail);
        } };
    }, update: function update() {
      var t = this.config,
          e = this.data;this.animationIsPlaying = !1, e.property && (t.autoplay = !1, t.direction = e.dir, t.duration = e.dur, t.easing = e.easing, t.elasticity = e.elasticity, t.loop = e.loop, this.createAndStartAnimation());
    }, tick: function tick(t, e) {
      this.animationIsPlaying && (this.time += e, this.animation.tick(this.time));
    }, remove: function remove() {
      this.pauseAnimation(), this.removeEventListeners();
    }, pause: function pause() {
      this.paused = !0, this.pausedWasPlaying = !0, this.pauseAnimation(), this.removeEventListeners();
    }, play: function play() {
      this.paused && (this.paused = !1, this.addEventListeners(), this.pausedWasPlaying && (this.resumeAnimation(), this.pausedWasPlaying = !1));
    }, createAndStartAnimation: function createAndStartAnimation() {
      var t = this.data;if (this.updateConfig(), this.animationIsPlaying = !1, this.animation = c(this.config), this.removeEventListeners(), this.addEventListeners(), !(!t.autoplay || t.startEvents && t.startEvents.length)) return t.delay ? void setTimeout(this.beginAnimation, t.delay) : void this.beginAnimation();
    }, beginAnimation: function beginAnimation() {
      this.updateConfig(), this.time = 0, this.animation.seek(0), this.animationIsPlaying = !0, this.stopRelatedAnimations(), this.el.emit("animationbegin", this.eventDetail);
    }, pauseAnimation: function pauseAnimation() {
      this.animationIsPlaying = !1;
    }, resumeAnimation: function resumeAnimation() {
      this.animationIsPlaying = !0;
    }, onStartEvent: function onStartEvent() {
      return this.data.delay ? void setTimeout(this.beginAnimation, this.data.delay) : void this.beginAnimation();
    }, updateConfigForRawColor: function updateConfigForRawColor() {
      var t,
          e,
          n,
          r = this.config,
          i = this.data,
          a = this.el;t = i.from || s(a, i.property), n = i.to, this.setColorConfig(t, n), t = this.fromColor, n = this.toColor, this.targetsArray.length = 0, this.targetsArray.push(t), r.targets = this.targetsArray;for (e in n) {
        r[e] = n[e];
      }r.update = function () {
        var e = {};return e.r = t.r, e.g = t.g, e.b = t.b, function (t) {
          var n;n = t.animatables[0].target, n.r === e.r && n.g === e.g && n.b === e.b || u(a, i.property, n, i.type);
        };
      }();
    }, updateConfigForDefault: function updateConfigForDefault() {
      var t,
          e,
          n,
          r,
          i = this.config,
          a = this.data,
          o = this.el;t = a.from || (l(a) ? s(o, a.property) : m(o, a.property)), r = a.to, n = !isNaN(t || r), n ? (t = parseFloat(t), r = parseFloat(r)) : (t = t ? t.toString() : t, r = r ? r.toString() : r), e = "true" === r || "false" === r, e && (t = "true" === a.from ? 1 : 0, r = "true" === a.to ? 1 : 0), this.targets.aframeProperty = t, i.targets = this.targets, i.aframeProperty = r, i.update = function () {
        var n = t;return function (t) {
          var r;r = t.animatables[0].target.aframeProperty, r !== n && (n = r, e && (r = r >= 1), l(a) ? u(o, a.property, r, a.type) : y(o, a.property, r));
        };
      }();
    }, updateConfigForVector: function updateConfigForVector() {
      var t,
          e,
          n,
          r = this.config,
          a = this.data,
          o = this.el;e = a.from ? AFRAME.utils.coordinates.parse(a.from) : m(o, a.property), n = AFRAME.utils.coordinates.parse(a.to), a.property === A && (i(e), i(n)), this.targetsArray.length = 0, this.targetsArray.push(e), r.targets = this.targetsArray;for (t in n) {
        r[t] = n[t];
      }return a.property === b || a.property === A || a.property === x ? void (r.update = function () {
        var t = {};return t.x = e.x, t.y = e.y, t.z = e.z, function (e) {
          var n = e.animatables[0].target;n.x === t.x && n.y === t.y && n.z === t.z || (t.x = n.x, t.y = n.y, t.z = n.z, o.object3D[a.property].set(n.x, n.y, n.z));
        };
      }()) : void (r.update = function () {
        var t = {};return t.x = e.x, t.y = e.y, t.z = e.z, function (e) {
          var n = e.animations[0].target;n.x === t.x && n.y === t.y && n.z === t.z || (t.x = n.x, t.y = n.y, t.z = n.z, y(o, a.property, n));
        };
      }());
    }, updateConfig: function updateConfig() {
      var t;t = r(this.el, this.data.property), l(this.data) && this.data.type === v ? this.updateConfigForRawColor() : "vec2" === t || "vec3" === t || "vec4" === t ? this.updateConfigForVector() : this.updateConfigForDefault();
    }, stopRelatedAnimations: function stopRelatedAnimations() {
      var t, e;for (e in this.el.components) {
        t = this.el.components[e], e !== this.attrName && "animation" === t.name && t.data.property === this.data.property && (t.animationIsPlaying = !1);
      }
    }, addEventListeners: function addEventListeners() {
      var t = this.data,
          e = this.el;a(e, t.startEvents, this.onStartEvent), a(e, t.pauseEvents, this.pauseAnimation), a(e, t.resumeEvents, this.resumeAnimation);
    }, removeEventListeners: function removeEventListeners() {
      var t = this.data,
          e = this.el;o(e, t.startEvents, this.onStartEvent), o(e, t.pauseEvents, this.pauseAnimation), o(e, t.resumeEvents, this.resumeAnimation);
    }, setColorConfig: function setColorConfig(t, e) {
      p.set(t), d.set(e), t = this.fromColor, e = this.toColor, t.r = p.r, t.g = p.g, t.b = p.b, e.r = d.r, e.g = d.g, e.b = d.b;
    } });
}, function (t, e, n) {
  var r, i, a;(function (n) {
    var o = { scope: {} };o.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function (t, e, n) {
      if (n.get || n.set) throw new TypeError("ES3 does not support getters and setters.");t != Array.prototype && t != Object.prototype && (t[e] = n.value);
    }, o.getGlobal = function (t) {
      return "undefined" != typeof window && window === t ? t : "undefined" != typeof n && null != n ? n : t;
    }, o.global = o.getGlobal(this), o.SYMBOL_PREFIX = "jscomp_symbol_", o.initSymbol = function () {
      o.initSymbol = function () {}, o.global.Symbol || (o.global.Symbol = o.Symbol);
    }, o.symbolCounter_ = 0, o.Symbol = function (t) {
      return o.SYMBOL_PREFIX + (t || "") + o.symbolCounter_++;
    }, o.initSymbolIterator = function () {
      o.initSymbol();var t = o.global.Symbol.iterator;t || (t = o.global.Symbol.iterator = o.global.Symbol("iterator")), "function" != typeof Array.prototype[t] && o.defineProperty(Array.prototype, t, { configurable: !0, writable: !0, value: function value() {
          return o.arrayIterator(this);
        } }), o.initSymbolIterator = function () {};
    }, o.arrayIterator = function (t) {
      var e = 0;return o.iteratorPrototype(function () {
        return e < t.length ? { done: !1, value: t[e++] } : { done: !0 };
      });
    }, o.iteratorPrototype = function (t) {
      return o.initSymbolIterator(), t = { next: t }, t[o.global.Symbol.iterator] = function () {
        return this;
      }, t;
    }, o.array = o.array || {}, o.iteratorFromArray = function (t, e) {
      o.initSymbolIterator(), t instanceof String && (t += "");var n = 0,
          r = { next: function next() {
          if (n < t.length) {
            var i = n++;return { value: e(i, t[i]), done: !1 };
          }return r.next = function () {
            return { done: !0, value: void 0 };
          }, r.next();
        } };return r[Symbol.iterator] = function () {
        return r;
      }, r;
    }, o.polyfill = function (t, e, n, r) {
      if (e) {
        for (n = o.global, t = t.split("."), r = 0; r < t.length - 1; r++) {
          var i = t[r];i in n || (n[i] = {}), n = n[i];
        }t = t[t.length - 1], r = n[t], e = e(r), e != r && null != e && o.defineProperty(n, t, { configurable: !0, writable: !0, value: e });
      }
    }, o.polyfill("Array.prototype.keys", function (t) {
      return t ? t : function () {
        return o.iteratorFromArray(this, function (t) {
          return t;
        });
      };
    }, "es6-impl", "es3");var s = this;!function (n, o) {
      i = [], r = o, a = "function" == typeof r ? r.apply(e, i) : r, !(void 0 !== a && (t.exports = a));
    }(this, function () {
      function t(t) {
        if (!D.col(t)) try {
          return document.querySelectorAll(t);
        } catch (t) {}
      }function e(t, e) {
        for (var n = t.length, r = 2 <= arguments.length ? arguments[1] : void 0, i = [], a = 0; a < n; a++) {
          if (a in t) {
            var o = t[a];e.call(r, o, a, t) && i.push(o);
          }
        }return i;
      }function n(t) {
        return t.reduce(function (t, e) {
          return t.concat(D.arr(e) ? n(e) : e);
        }, []);
      }function r(e) {
        return D.arr(e) ? e : (D.str(e) && (e = t(e) || e), e instanceof NodeList || e instanceof HTMLCollection ? [].slice.call(e) : [e]);
      }function i(t, e) {
        return t.some(function (t) {
          return t === e;
        });
      }function a(t) {
        var e,
            n = {};for (e in t) {
          n[e] = t[e];
        }return n;
      }function o(t, e) {
        var n,
            r = a(t);for (n in t) {
          r[n] = e.hasOwnProperty(n) ? e[n] : t[n];
        }return r;
      }function u(t, e) {
        var n,
            r = a(t);for (n in e) {
          r[n] = D.und(t[n]) ? e[n] : t[n];
        }return r;
      }function f(t) {
        t = t.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function (t, e, n, r) {
          return e + e + n + n + r + r;
        });var e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(t);t = parseInt(e[1], 16);var n = parseInt(e[2], 16),
            e = parseInt(e[3], 16);return "rgba(" + t + "," + n + "," + e + ",1)";
      }function l(t) {
        function e(t, e, n) {
          return 0 > n && (n += 1), 1 < n && --n, n < 1 / 6 ? t + 6 * (e - t) * n : .5 > n ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
        }var n = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(t) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(t);t = parseInt(n[1]) / 360;var r = parseInt(n[2]) / 100,
            i = parseInt(n[3]) / 100,
            n = n[4] || 1;if (0 == r) i = r = t = i;else {
          var a = .5 > i ? i * (1 + r) : i + r - i * r,
              o = 2 * i - a,
              i = e(o, a, t + 1 / 3),
              r = e(o, a, t);t = e(o, a, t - 1 / 3);
        }return "rgba(" + 255 * i + "," + 255 * r + "," + 255 * t + "," + n + ")";
      }function c(t) {
        if (t = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(t)) return t[2];
      }function p(t) {
        return -1 < t.indexOf("translate") || "perspective" === t ? "px" : -1 < t.indexOf("rotate") || -1 < t.indexOf("skew") ? "deg" : void 0;
      }function d(t, e) {
        return D.fnc(t) ? t(e.target, e.id, e.total) : t;
      }function h(t, e) {
        if (e in t.style) return getComputedStyle(t).getPropertyValue(e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
      }function m(t, e) {
        return D.dom(t) && i(N, e) ? "transform" : D.dom(t) && (t.getAttribute(e) || D.svg(t) && t[e]) ? "attribute" : D.dom(t) && "transform" !== e && h(t, e) ? "css" : null != t[e] ? "object" : void 0;
      }function y(t, n) {
        var r = p(n),
            r = -1 < n.indexOf("scale") ? 1 : 0 + r;if (t = t.style.transform, !t) return r;for (var i = [], a = [], o = [], s = /(\w+)\((.+?)\)/g; i = s.exec(t);) {
          a.push(i[1]), o.push(i[2]);
        }return t = e(o, function (t, e) {
          return a[e] === n;
        }), t.length ? t[0] : r;
      }function g(t, e) {
        switch (m(t, e)) {case "transform":
            return y(t, e);case "css":
            return h(t, e);case "attribute":
            return t.getAttribute(e);}return t[e] || 0;
      }function v(t, e) {
        var n = /^(\*=|\+=|-=)/.exec(t);if (!n) return t;var r = c(t) || 0;switch (e = parseFloat(e), t = parseFloat(t.replace(n[0], "")), n[0][0]) {case "+":
            return e + t + r;case "-":
            return e - t + r;case "*":
            return e * t + r;}
      }function b(t, e) {
        return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
      }function A(t) {
        t = t.points;for (var e, n = 0, r = 0; r < t.numberOfItems; r++) {
          var i = t.getItem(r);0 < r && (n += b(e, i)), e = i;
        }return n;
      }function x(t) {
        if (t.getTotalLength) return t.getTotalLength();switch (t.tagName.toLowerCase()) {case "circle":
            return 2 * Math.PI * t.getAttribute("r");case "rect":
            return 2 * t.getAttribute("width") + 2 * t.getAttribute("height");case "line":
            return b({ x: t.getAttribute("x1"), y: t.getAttribute("y1") }, { x: t.getAttribute("x2"), y: t.getAttribute("y2") });case "polyline":
            return A(t);case "polygon":
            var e = t.points;return A(t) + b(e.getItem(e.numberOfItems - 1), e.getItem(0));}
      }function E(t, e) {
        function n(n) {
          return n = void 0 === n ? 0 : n, t.el.getPointAtLength(1 <= e + n ? e + n : 0);
        }var r = n(),
            i = n(-1),
            a = n(1);switch (t.property) {case "x":
            return r.x;case "y":
            return r.y;case "angle":
            return 180 * Math.atan2(a.y - i.y, a.x - i.x) / Math.PI;}
      }function w(t, e) {
        var n,
            r = /-?\d*\.?\d+/g;if (n = D.pth(t) ? t.totalLength : t, D.col(n)) {
          if (D.rgb(n)) {
            var i = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(n);n = i ? "rgba(" + i[1] + ",1)" : n;
          } else n = D.hex(n) ? f(n) : D.hsl(n) ? l(n) : void 0;
        } else i = (i = c(n)) ? n.substr(0, n.length - i.length) : n, n = e && !/\s/g.test(n) ? i + e : i;return n += "", { original: n, numbers: n.match(r) ? n.match(r).map(Number) : [0], strings: D.str(t) || e ? n.split(r) : [] };
      }function P(t) {
        return t = t ? n(D.arr(t) ? t.map(r) : r(t)) : [], e(t, function (t, e, n) {
          return n.indexOf(t) === e;
        });
      }function C(t) {
        var e = P(t);return e.map(function (t, n) {
          return { target: t, id: n, total: e.length };
        });
      }function I(t, e) {
        var n = a(e);if (D.arr(t)) {
          var i = t.length;2 !== i || D.obj(t[0]) ? D.fnc(e.duration) || (n.duration = e.duration / i) : t = { value: t };
        }return r(t).map(function (t, n) {
          return n = n ? 0 : e.delay, t = D.obj(t) && !D.pth(t) ? t : { value: t }, D.und(t.delay) && (t.delay = n), t;
        }).map(function (t) {
          return u(t, n);
        });
      }function M(t, e) {
        var n,
            r = {};for (n in t) {
          var i = d(t[n], e);D.arr(i) && (i = i.map(function (t) {
            return d(t, e);
          }), 1 === i.length && (i = i[0])), r[n] = i;
        }return r.duration = parseFloat(r.duration), r.delay = parseFloat(r.delay), r;
      }function S(t) {
        return D.arr(t) ? $.apply(this, t) : H[t];
      }function F(t, e) {
        var n;return t.tweens.map(function (r) {
          r = M(r, e);var i = r.value,
              a = g(e.target, t.name),
              o = n ? n.to.original : a,
              o = D.arr(i) ? i[0] : o,
              s = v(D.arr(i) ? i[1] : i, o),
              a = c(s) || c(o) || c(a);return r.from = w(o, a), r.to = w(s, a), r.start = n ? n.end : t.offset, r.end = r.start + r.delay + r.duration, r.easing = S(r.easing), r.elasticity = (1e3 - Math.min(Math.max(r.elasticity, 1), 999)) / 1e3, r.isPath = D.pth(i), r.isColor = D.col(r.from.original), r.isColor && (r.round = 1), n = r;
        });
      }function R(t, r) {
        return e(n(t.map(function (t) {
          return r.map(function (e) {
            var n = m(t.target, e.name);if (n) {
              var r = F(e, t);e = { type: n, property: e.name, animatable: t, tweens: r, duration: r[r.length - 1].end, delay: r[0].delay };
            } else e = void 0;return e;
          });
        })), function (t) {
          return !D.und(t);
        });
      }function O(t, e, n, r) {
        var i = "delay" === t;return e.length ? (i ? Math.min : Math.max).apply(Math, e.map(function (e) {
          return e[t];
        })) : i ? r.delay : n.offset + r.delay + r.duration;
      }function L(t) {
        var e,
            n = o(z, t),
            r = o(j, t),
            i = C(t.targets),
            a = [],
            s = u(n, r);for (e in t) {
          s.hasOwnProperty(e) || "targets" === e || a.push({ name: e, offset: s.offset, tweens: I(t[e], r) });
        }return t = R(i, a), u(n, { children: [], animatables: i, animations: t, duration: O("duration", t, n, r), delay: O("delay", t, n, r) });
      }function T(t) {
        function n() {
          return window.Promise && new Promise(function (t) {
            return c = t;
          });
        }function r(t) {
          return d.reversed ? d.duration - t : t;
        }function i(t) {
          for (var n = 0, r = {}, i = d.animations, a = i.length; n < a;) {
            var o = i[n],
                s = o.animatable,
                u = o.tweens,
                f = u.length - 1,
                l = u[f];f && (l = e(u, function (e) {
              return t < e.end;
            })[0] || l);for (var u = Math.min(Math.max(t - l.start - l.delay, 0), l.duration) / l.duration, c = isNaN(u) ? 1 : l.easing(u, l.elasticity), u = l.to.strings, p = l.round, f = [], m = void 0, m = l.to.numbers.length, y = 0; y < m; y++) {
              var g = void 0,
                  g = l.to.numbers[y],
                  v = l.from.numbers[y],
                  g = l.isPath ? E(l.value, c * g) : v + c * (g - v);p && (l.isColor && 2 < y || (g = Math.round(g * p) / p)), f.push(g);
            }if (l = u.length) for (m = u[0], c = 0; c < l; c++) {
              p = u[c + 1], y = f[c], isNaN(y) || (m = p ? m + (y + p) : m + (y + " "));
            } else m = f[0];V[o.type](s.target, o.property, m, r, s.id), o.currentValue = m, n++;
          }if (n = Object.keys(r).length) for (i = 0; i < n; i++) {
            k || (k = h(document.body, "transform") ? "transform" : "-webkit-transform"), d.animatables[i].target.style[k] = r[i].join(" ");
          }d.currentTime = t, d.progress = t / d.duration * 100;
        }function a(t) {
          d[t] && d[t](d);
        }function o() {
          d.remaining && !0 !== d.remaining && d.remaining--;
        }function s(t) {
          var e = d.duration,
              s = d.offset,
              h = s + d.delay,
              m = d.currentTime,
              y = d.reversed,
              g = r(t);if (d.children.length) {
            var v = d.children,
                b = v.length;if (g >= d.currentTime) for (var A = 0; A < b; A++) {
              v[A].seek(g);
            } else for (; b--;) {
              v[b].seek(g);
            }
          }(g >= h || !e) && (d.began || (d.began = !0, a("begin")), a("run")), g > s && g < e ? i(g) : (g <= s && 0 !== m && (i(0), y && o()), (g >= e && m !== e || !e) && (i(e), y || o())), a("update"), t >= e && (d.remaining ? (f = u, "alternate" === d.direction && (d.reversed = !d.reversed)) : (d.pause(), d.completed || (d.completed = !0, a("complete"), "Promise" in window && (c(), p = n()))), l = 0);
        }t = void 0 === t ? {} : t;var u,
            f,
            l = 0,
            c = null,
            p = n(),
            d = L(t);return d.reset = function () {
          var t = d.direction,
              e = d.loop;for (d.currentTime = 0, d.progress = 0, d.paused = !0, d.began = !1, d.completed = !1, d.reversed = "reverse" === t, d.remaining = "alternate" === t && 1 === e ? 2 : e, i(0), t = d.children.length; t--;) {
            d.children[t].reset();
          }
        }, d.tick = function (t) {
          u = t, f || (f = u), s((l + u - f) * T.speed);
        }, d.seek = function (t) {
          s(r(t));
        }, d.pause = function () {
          var t = X.indexOf(d);-1 < t && X.splice(t, 1), d.paused = !0;
        }, d.play = function () {
          d.paused && (d.paused = !1, f = 0, l = r(d.currentTime), X.push(d), Y || _());
        }, d.reverse = function () {
          d.reversed = !d.reversed, f = 0, l = r(d.currentTime);
        }, d.restart = function () {
          d.pause(), d.reset(), d.play();
        }, d.finished = p, d.reset(), d.autoplay && d.play(), d;
      }var k,
          z = { update: void 0, begin: void 0, run: void 0, complete: void 0, loop: 1, direction: "normal", autoplay: !0, offset: 0 },
          j = { duration: 1e3, delay: 0, easing: "easeOutElastic", elasticity: 500, round: 0 },
          N = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),
          D = { arr: function arr(t) {
          return Array.isArray(t);
        }, obj: function obj(t) {
          return -1 < Object.prototype.toString.call(t).indexOf("Object");
        }, pth: function pth(t) {
          return D.obj(t) && t.hasOwnProperty("totalLength");
        }, svg: function svg(t) {
          return t instanceof SVGElement;
        }, dom: function dom(t) {
          return t.nodeType || D.svg(t);
        }, str: function str(t) {
          return "string" == typeof t;
        }, fnc: function fnc(t) {
          return "function" == typeof t;
        }, und: function und(t) {
          return "undefined" == typeof t;
        }, hex: function hex(t) {
          return (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(t)
          );
        }, rgb: function rgb(t) {
          return (/^rgb/.test(t)
          );
        }, hsl: function hsl(t) {
          return (/^hsl/.test(t)
          );
        }, col: function col(t) {
          return D.hex(t) || D.rgb(t) || D.hsl(t);
        } },
          $ = function () {
        function t(t, e, n) {
          return (((1 - 3 * n + 3 * e) * t + (3 * n - 6 * e)) * t + 3 * e) * t;
        }return function (e, n, r, i) {
          if (0 <= e && 1 >= e && 0 <= r && 1 >= r) {
            var a = new Float32Array(11);if (e !== n || r !== i) for (var o = 0; 11 > o; ++o) {
              a[o] = t(.1 * o, e, r);
            }return function (o) {
              if (e === n && r === i) return o;if (0 === o) return 0;if (1 === o) return 1;for (var s = 0, u = 1; 10 !== u && a[u] <= o; ++u) {
                s += .1;
              }--u;var u = s + (o - a[u]) / (a[u + 1] - a[u]) * .1,
                  f = 3 * (1 - 3 * r + 3 * e) * u * u + 2 * (3 * r - 6 * e) * u + 3 * e;if (.001 <= f) {
                for (s = 0; 4 > s && (f = 3 * (1 - 3 * r + 3 * e) * u * u + 2 * (3 * r - 6 * e) * u + 3 * e, 0 !== f); ++s) {
                  var l = t(u, e, r) - o,
                      u = u - l / f;
                }o = u;
              } else if (0 === f) o = u;else {
                var u = s,
                    s = s + .1,
                    c = 0;do {
                  l = u + (s - u) / 2, f = t(l, e, r) - o, 0 < f ? s = l : u = l;
                } while (1e-7 < Math.abs(f) && 10 > ++c);o = l;
              }return t(o, n, i);
            };
          }
        };
      }(),
          H = function () {
        function t(t, e) {
          return 0 === t || 1 === t ? t : -Math.pow(2, 10 * (t - 1)) * Math.sin(2 * (t - 1 - e / (2 * Math.PI) * Math.asin(1)) * Math.PI / e);
        }var e,
            n = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),
            r = { In: [[.55, .085, .68, .53], [.55, .055, .675, .19], [.895, .03, .685, .22], [.755, .05, .855, .06], [.47, 0, .745, .715], [.95, .05, .795, .035], [.6, .04, .98, .335], [.6, -.28, .735, .045], t], Out: [[.25, .46, .45, .94], [.215, .61, .355, 1], [.165, .84, .44, 1], [.23, 1, .32, 1], [.39, .575, .565, 1], [.19, 1, .22, 1], [.075, .82, .165, 1], [.175, .885, .32, 1.275], function (e, n) {
            return 1 - t(1 - e, n);
          }], InOut: [[.455, .03, .515, .955], [.645, .045, .355, 1], [.77, 0, .175, 1], [.86, 0, .07, 1], [.445, .05, .55, .95], [1, 0, 0, 1], [.785, .135, .15, .86], [.68, -.55, .265, 1.55], function (e, n) {
            return .5 > e ? t(2 * e, n) / 2 : 1 - t(-2 * e + 2, n) / 2;
          }] },
            i = { linear: $(.25, .25, .75, .75) },
            a = {};for (e in r) {
          a.type = e, r[a.type].forEach(function (t) {
            return function (e, r) {
              i["ease" + t.type + n[r]] = D.fnc(e) ? e : $.apply(s, e);
            };
          }(a)), a = { type: a.type };
        }return i;
      }(),
          V = { css: function css(t, e, n) {
          return t.style[e] = n;
        }, attribute: function attribute(t, e, n) {
          return t.setAttribute(e, n);
        }, object: function object(t, e, n) {
          return t[e] = n;
        }, transform: function transform(t, e, n, r, i) {
          r[i] || (r[i] = []), r[i].push(e + "(" + n + ")");
        } },
          X = [],
          Y = 0,
          _ = function () {
        function t() {
          Y = requestAnimationFrame(e);
        }function e(e) {
          var n = X.length;if (n) {
            for (var r = 0; r < n;) {
              X[r] && X[r].tick(e), r++;
            }t();
          } else cancelAnimationFrame(Y), Y = 0;
        }return t;
      }();return T.version = "2.2.0", T.speed = 1, T.running = X, T.remove = function (t) {
        t = P(t);for (var e = X.length; e--;) {
          for (var n = X[e], r = n.animations, a = r.length; a--;) {
            i(t, r[a].animatable.target) && (r.splice(a, 1), r.length || n.pause());
          }
        }
      }, T.getValue = g, T.path = function (e, n) {
        var r = D.str(e) ? t(e)[0] : e,
            i = n || 100;return function (t) {
          return { el: r, property: t, totalLength: x(r) * (i / 100) };
        };
      }, T.setDashoffset = function (t) {
        var e = x(t);return t.setAttribute("stroke-dasharray", e), e;
      }, T.bezier = $, T.easings = H, T.timeline = function (t) {
        var e = T(t);return e.pause(), e.duration = 0, e.add = function (n) {
          return e.children.forEach(function (t) {
            t.began = !0, t.completed = !0;
          }), r(n).forEach(function (n) {
            var r = u(n, o(j, t || {}));r.targets = r.targets || t.targets, n = e.duration;var i = r.offset;r.autoplay = !1, r.direction = e.direction, r.offset = D.und(i) ? n : v(i, n), e.began = !0, e.completed = !0, e.seek(r.offset), r = T(r), r.began = !0, r.completed = !0, r.duration > n && (e.duration = r.duration), e.children.push(r);
          }), e.seek(0), e.reset(), e.autoplay && e.restart(), e;
        }, e;
      }, T.random = function (t, e) {
        return Math.floor(Math.random() * (e - t + 1)) + t;
      }, T;
    });
  }).call(e, function () {
    return this;
  }());
}]);

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t) {
  function e(n) {
    if (i[n]) return i[n].exports;var a = i[n] = { exports: {}, id: n, loaded: !1 };return t[n].call(a.exports, a, a.exports, e), a.loaded = !0, a.exports;
  }var i = {};return e.m = t, e.c = i, e.p = "", e(0);
}([function (t, e) {
  function i(t) {
    var e,
        i = {};for (e in t) {
      "function" == typeof t[e] ? i[e] = t[e] : "object" == _typeof(t[e]) ? i[e] = AFRAME.utils.clone(t[e]) : i[e] = t[e];
    }return i;
  }document.registerElement("a-timeline"), document.registerElement("a-timeline-group"), document.registerElement("a-timeline-animation"), AFRAME.registerComponent("animation-timeline", { schema: { direction: { type: "string", default: "normal" }, loop: { default: 0, parse: function parse(t) {
          return "true" === t || "false" !== t && parseInt(t, 10);
        } }, startEvents: { type: "array" }, timeline: { type: "string" } }, multiple: !0, init: function init() {
      var t,
          e = this.data;for (this.animationIsPlaying = !1, this.beginAnimation = this.beginAnimation.bind(this), this.eventDetail = { name: this.id }, this.time = 0, this.timeline = null, t = 0; t < e.startEvents.length; t++) {
        this.el.addEventListener(e.startEvents[t], this.beginAnimation);
      }
    }, play: function play() {
      this.data.startEvents.length || this.beginAnimation();
    }, tick: function tick(t, e) {
      this.animationIsPlaying && this.timeline && (this.time += e, this.timeline.tick(this.time));
    }, beginAnimation: function beginAnimation() {
      var t,
          e,
          i,
          n,
          a,
          o,
          r,
          l = this;if (o = document.querySelector(this.data.timeline), "A-TIMELINE" !== o.tagName) throw new Error("[animation-timeline] timeline must be a selector to <a-timeline> element.");for (this.animationIsPlaying = !0, this.time = 0, this.timeline = AFRAME.anime.timeline({ autoplay: !1, complete: function complete() {
          l.el.emit("animationtimelinecomplete", l.eventDetail);
        }, direction: this.data.direction, loop: this.data.loop }), a = 0, t = 0; t < o.children.length; t++) {
        if ("A-TIMELINE-GROUP" !== o.children[t].tagName) "A-TIMELINE-ANIMATION" === o.children[t].tagName && (a += this.addAnimationToTimeline(o.children[t], a));else {
          for (r = o.children[t], n = 0, e = 0; e < r.children.length; e++) {
            i = this.addAnimationToTimeline(r.children[e], a), i > n && (n = i);
          }a += n;
        }
      }
    }, addAnimationToTimeline: function addAnimationToTimeline(t, e) {
      var n, a, o, r, l, s, m;if (a = "animation__" + t.getAttribute("name"), m = t.getAttribute("select"), l = this.el.sceneEl.querySelectorAll(m), !l.length) return console.warn('[animation-timeline] No entities found for select="' + m + '"'), 0;for (n = parseFloat(t.getAttribute("offset") || 0, 10), s = 0; s < l.length; s++) {
        if (o = l[s].components[a], !o) throw new Error("Could not find animation `" + a + "` for `" + t.getAttribute("select") + "`.");o.updateConfig(), r = i(o.config), r.offset = e + n, this.timeline.add(r);
      }return (r.duration || 0) + (r.delay || 0) + n;
    } });
}]);

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('teleport-extras', {
  schema: {
    cursor: { type: 'selector', default: '[cursor]' }
  },

  active: true,

  init: function init() {
    document.querySelector('a-scene').addEventListener('touchstart', this.startTouch.bind(this));
    document.querySelector('a-scene').addEventListener('mousedown', this.startTouch.bind(this));
    document.body.addEventListener('keydown', function (e) {
      if (e.keyCode == 32) {
        this.startTouch();
      }
    }.bind(this));

    //Create the touchend event
    document.querySelector('a-scene').addEventListener('touchend', this.endTouch.bind(this));
    document.querySelector('a-scene').addEventListener('mouseup', this.endTouch.bind(this));
    document.body.addEventListener('keyup', function (e) {
      if (e.keyCode == 32) {
        this.endTouch();
      }
    }.bind(this));

    this.el.addEventListener('raycaster-intersection', this.onStartIntersection.bind(this));
    this.el.addEventListener('raycaster-intersection-cleared', this.onEndIntersection.bind(this));
  },

  startTouch: function startTouch() {
    if (this.active) {
      this.el.emit('starttouch');
    }
  },

  endTouch: function endTouch() {
    if (this.active) {
      this.el.emit('endtouch');
    }
  },

  onStartIntersection: function onStartIntersection() {
    this.active = false;

    var teleportControls = this.el.components['teleport-controls'];
    teleportControls.active = false;
    teleportControls.hitEntity.setAttribute('visible', false);
    teleportControls.teleportEntity.setAttribute('visible', false);
  },

  onEndIntersection: function onEndIntersection() {
    this.active = true;
  }
});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('toggle-on-event', {
  schema: {
    hideOn: { type: 'string', default: 'raycaster-intersection-cleared' },
    showOn: { type: 'string', default: 'raycaster-intersection' },
    raycasterObject: { type: 'selector' }
  },

  noIntersections: 0,

  init: function init() {
    if (!this.data.raycasterObject) {
      this.data.raycasterObject = this.el;
    }

    this.data.raycasterObject.addEventListener(this.data.showOn, function () {
      this.noIntersections++;
      this.toggle();
    }.bind(this));

    this.data.raycasterObject.addEventListener(this.data.hideOn, function () {
      this.noIntersections--;
      this.toggle();
    }.bind(this));
  },

  toggle: function toggle() {
    this.noIntersections = Math.max(this.noIntersections, 0);
    this.el.setAttribute('visible', this.noIntersections > 0);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('lookatlabel', {
  init: function init() {
    this.vector = new THREE.Vector3();
  },

  tick: function tick(t) {
    var self = this;
    var target = self.el.sceneEl.camera;
    var object3D = self.el.object3D;

    // make sure camera is set
    if (target) {
      target.updateMatrixWorld();
      this.vector.setFromMatrixPosition(target.matrixWorld);
      if (object3D.parent) {
        object3D.parent.updateMatrixWorld();
        object3D.parent.worldToLocal(this.vector);
      }
      //    return object3D.lookAt(this.vector); 
      return object3D.lookAt(new THREE.Vector3(this.vector.x, object3D.position.y, this.vector.z));
    }
  }
});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('ui-console', {
  schema: {
    product: {
      type: 'string',
      default: ''
    },
    rig: {
      type: 'string',
      default: '#cameraRig'
    },
    radius: {
      type: 'number',
      default: 0.75
    },
    triggered: {
      type: 'boolean',
      default: false
    }
  },

  init: function init() {
    var data = this.data;
    var el = this.el;
    var cameraRig = document.querySelector(data.rig);
    var uiEl = this.uiEl = el.object3D.parent;
    var rigEl = this.rigEl = cameraRig.object3D;
    //    this.hide();
  },
  tick: function tick(time, delta) {
    if (this.data.triggered) {

      // if (this.data.product === "ucaas") {
      //   var positionX = this.rigEl.position.x;
      //   var positionZ = this.rigEl.position.z;

      //   if (positionX < 1 && positionX > -1) {
      //     var showUcaaS = true
      //   } else {
      //     showUcaaS = false;
      //   }
      // }

      // var dist = this.calcDistance(this.uiEl.position.x, this.uiEl.position.z, this.rigEl.position.x, this.rigEl.position.z);
      // if (dist < this.data.radius || showUcaaS) {
      //   if (this.el.getAttribute('visible') === false) {
      //     this.show();
      //   }
    } else {
      var dist = this.calcDistance(this.uiEl.position.x, this.uiEl.position.z, this.rigEl.position.x, this.rigEl.position.z);
      if (dist < this.data.radius) {
        if (this.el.getAttribute('visible') === false) {
          this.show();
        }
      } else {
        if (this.el.getAttribute('visible') === true) {
          this.hide();
        }
      }
    }
  },
  calcDistance: function calcDistance(x1, z1, x2, z2) {
    return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(z2 - z1, 2));
  },
  show: function show() {
    //    console.log(">>>>>>>> showing: " + this.data.product);
    this.el.setAttribute('visible', 'true');
  },
  hide: function hide() {
    //    console.log(">>>>>>>> hiding: " + this.data.product);
    this.el.setAttribute('visible', 'false');
  },
  update: function update(oldData) {}
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('checkpointspot', {
  schema: {
    radius: { type: 'number', default: 0.45 },
    color: { type: 'string', default: '#2d283d' },
    texture: { type: 'string', default: '#centertexture' },
    rayobj: { type: 'string', default: '' }
  },

  init: function init() {
    var data = this.data;
    var el = this.el;

    el.setAttribute('geometry', 'primitive: circle; radius: ' + data.radius + ';');
    el.setAttribute('material', 'opacity:0.45; color:' + data.color + '; src:' + data.texture + ';');
    el.setAttribute('rotation', '-90 0 0');
    el.setAttribute('position', '0 0.1 0');
    if (data.rayobj) {
      el.setAttribute('class', data.rayobj);
    }

    var ring = document.createElement("a-entity");
    ring.setAttribute('geometry', 'primitive:ring; radiusInner:0.3; radiusOuter:0.4;');
    ring.setAttribute('material', 'shader:flat; color:#fff; src:' + data.texture + ';');
    ring.setAttribute('position', '0 0 0.05');
    ring.setAttribute('animation__in', 'property: geometry.radiusInner; to: 0.5; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false'), ring.setAttribute('animation__in2', 'property: geometry.radiusOuter; to: 0.55; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false'), ring.setAttribute('animation__in3', 'property: position; to: 0 0 0; delay: 0; dur: 500; easing: easeInOutSine; startEvents: in; autoplay: false'), ring.setAttribute('animation__out', 'property: geometry.radiusInner; to: 0.3; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false'), ring.setAttribute('animation__out2', 'property: geometry.radiusOuter; to: 0.4; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false'), ring.setAttribute('animation__out3', 'property: position; to: 0 0 0.05; delay: 0; dur: 200; easing: easeInOutSine; startEvents: out; autoplay: false'), el.appendChild(ring);

    el.addEventListener('mouseenter', function () {
      ring.emit('in');
    });

    el.addEventListener('mouseleave', function () {
      ring.emit('out');
    });
  },
  play: function play() {},
  update: function update(oldData) {}
});

/*
  <a-animation begin="mouseenter" attribute="geometry.radiusInner" from="0.1" to="0.3" dur="500"></a-animation>
  <a-animation begin="mouseout" attribute="geometry.radiusInner" from="0.3" to="0.1" dur="200"></a-animation>
*/

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

var CURRENT_VIDEO;
var WATCHING_VIDEO = false;

//SAVE CURRENT VIDEO SRC TO CURRENT_VIDEO ELEMENT
AFRAME.registerComponent('video-controls', {
  schema: {
    videoSrcURL: {
      type: 'string'
    }
  },
  init: function init() {
    var videoSrcURL = this.data.videoSrcURL;
    var videoElement = document.querySelector(videoSrcURL);

    //Click Platform -> Hide Video -> Set video Src -> Position Video
    this.el.addEventListener('click', function (event) {
      CURRENT_VIDEO = document.querySelector(videoElement.attributes.src.value);
      console.log('video-controls component CURRENT_VIDEO: ' + CURRENT_VIDEO, "WATCHING_VIDEO:", WATCHING_VIDEO);

      vidplay();
    });
  }
});

function hideVideos() {
  var videoElementArray = document.querySelectorAll("a-video");

  videoElementArray.forEach(function (vidElement) {

    // Set visibility of video
    vidElement.setAttribute('visible', false);
  });

  //Reset timing of current video when hidden.
  CURRENT_VIDEO.currentTime = 0;
}

//PLAY CURRENT_VIDEO (called at bottom of index.html when <body>.click())
function vidplay() {
  var video = CURRENT_VIDEO;
  console.log('CURRENT_VIDEO: ' + CURRENT_VIDEO);

  if (video.paused) {
    var playPromise = video.play();

    // In browsers that don’t yet support this functionality,
    // playPromise won’t be defined.
    if (playPromise !== undefined) {
      playPromise.then(function () {
        // Automatic playback started!
      }).catch(function (error) {
        // Automatic playback failed.
        // Show a UI element to let the user manually start playback.
        console.log(error);
      });
    }
  } else {
    video.pause();
  }
}

// //
// function setVideoVisibilityTrue(videoElement) {
//   videoElement.setAttribute('visible', true);
// }

//WATCHING VIDEO COMPONENT
AFRAME.registerComponent('watching-video', {
  init: function init() {

    this.el.addEventListener('mouseenter', function (event) {
      WATCHING_VIDEO = true;
      console.log("WATCHING_VIDEO = true");
    });

    this.el.addEventListener('mouseleave', function (event) {
      WATCHING_VIDEO = false;
      console.log("WATCHING_VIDEO = false");
    });
  }
});

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('panel', {
  schema: {
    width: { type: 'number', default: 0.75 },
    height: { type: 'number', default: 0.5 },
    copy: { type: 'string', default: '#panel-chime' }
  },

  init: function init() {
    var data = this.data;
    var el = this.el;

    el.setAttribute('geometry', 'primitive: plane; height: ' + data.height + '; width: ' + data.width + ';');
    el.setAttribute('material', 'transparent: true; opacity:1; color:#fff; src:' + data.copy + ';');
  },
  play: function play() {},
  update: function update(oldData) {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base_url = "https://backend-vonagevrcpev2.herokuapp.com";

if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('panelbtn', {
  schema: {
    on: {
      default: 'click'
    },
    width: {
      type: 'number',
      default: 0.75
    },
    height: {
      type: 'number',
      default: 0.125
    },
    toggle: {
      type: 'boolean',
      default: false
    },
    base: {
      type: 'string',
      default: '#bookmark-btn-label'
    },
    hover: {
      type: 'string',
      default: '#bookmark-btn-label-hover'
    },
    click: {
      type: 'string',
      default: '#bookmark-btn-label-click'
    },
    clickAction: {
      type: 'string'
    },
    hoversnd: { type: 'string', default: 'panelhoversound' },
    clicksnd: { type: 'string', default: 'panelclicksound' }
  },

  init: function init() {
    var data = this.data;
    var el = this.el;
    var toggleState = this.toggleState = data.toggle;
    var hoversound = this.opensound = document.getElementById(data.hoversnd);
    var clicksound = this.coinsound = document.getElementById(data.clicksnd);
    el.setAttribute('geometry', 'primitive: plane; height: ' + data.height + '; width: ' + data.width + ';');
    el.setAttribute('material', 'transparent: true; opacity:1; color:#fff; src:' + data.base + ';');

    el.addEventListener('mouseenter', function () {
      if (!data.toggle) {
        this.setAttribute('material', 'src', data.hover);
      }
      this.setAttribute('scale', '1.15 1.15 1.15');
      hoversound.components.sound.stopSound();hoversound.components.sound.playSound();
    });

    el.addEventListener('mouseleave', function () {
      if (!data.toggle) {
        this.setAttribute('material', 'src', data.base);
      }
      this.setAttribute('scale', '1 1 1');
    });

    el.addEventListener('mousedown', function () {
      if (!data.toggle) {
        this.setAttribute('material', 'src', data.click);
      } else {
        this.setAttribute('material', 'src', data.hover);
      }
    });
    el.addEventListener('mouseup', function () {
      if (!data.toggle) {
        this.setAttribute('material', 'src', data.hover);
      } else {
        this.setAttribute('material', 'src', data.click);
      }
    });

    el.addEventListener(data.on, function (evt) {

      console.log('I was clicked at: ', evt.detail.intersection.point);

      clicksound.components.sound.stopSound();clicksound.components.sound.playSound();

      var clickActionFunctionName = data.clickAction;
      console.log("in button, clickActionFunctionName: " + clickActionFunctionName);

      //BOOKMARK SERVICE USER CLICKS
      //Param: 'bookmarkvonagereach'
      if (clickActionFunctionName.includes("bookmark")) {
        var user = JSON.parse(localStorage.getItem('active_user'));
        user["bookmarkedService"] = clickActionFunctionName.split("bookmark")[1];

        userBookmarkService(user);
      }
      // find object
      var clickActionFunction = window[clickActionFunctionName];
      //console.log("clickActionFunction: "+clickActionFunction);
      // is object a function?
      if (typeof clickActionFunction === "function") clickActionFunction();
    });
  },
  setClickAction: function setClickAction(action) {
    this.data.clickAction = action; //change function dynamically
  },
  play: function play() {},
  update: function update(oldData) {
    console.log("In button update, toggle: " + this.toggleState);
  },
  setActiveState: function setActiveState(activeState) {
    console.log("in setActiveState function");
    this.data.toggle = this.toggleState = activeState;
    if (!activeState) {
      this.setAttribute('material', 'src', this.data.base);
    } else {}
  }
});

function userBookmarkService(user) {
  console.log("Bookmarking: ", user.bookmarkedService, " for ", user.email);

  $.ajax({
    url: base_url + '/user',
    type: 'GET',
    dataType: 'jsonp',
    data: user,
    success: function success(data) {
      return data;
    },
    error: function error(err) {
      console.log('Failed!', err);
      return err;
    }
  });
}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof AFRAME === 'undefined') {
  throw new Error('Component attempted to register before AFRAME was available.');
}

AFRAME.registerComponent('trunk', {
  schema: {
    on: { default: 'click' },
    clue: { type: 'string', default: '#panel-trunk' },
    opensnd: { type: 'string', default: 'trunkopensound' },
    coinsnd: { type: 'string', default: 'trunkcoinsound' },
    clickAction: { type: 'string' }
  },

  init: function init() {
    var data = this.data;
    var el = this.el;
    var opensound = this.opensound = document.getElementById(data.opensnd);
    var coinsound = this.coinsound = document.getElementById(data.coinsnd);

    el.setAttribute('geometry', 'primitive:box; width:1; height:1;depth:1');
    el.setAttribute('material', 'transparent: true; opacity:0; color:#fff;');

    var base = document.createElement("a-entity");
    base.setAttribute('obj-model', 'obj: #trunk_base-obj; mtl: #trunk_base-mtl');
    base.setAttribute('scale', '0.5 0.5 0.5');
    base.setAttribute('position', '0 0 0');
    el.appendChild(base);

    var lid = document.createElement("a-entity");
    lid.setAttribute('obj-model', 'obj: #trunk_top-obj; mtl: #trunk_top-mtl');
    lid.setAttribute('scale', '0.5 0.5 0.5');
    lid.setAttribute('position', '0 0 0');
    el.appendChild(lid);

    var trunklidAni = document.createElement("a-animation");
    trunklidAni.setAttribute('attribute', 'rotation');
    trunklidAni.setAttribute('begin', 'reveal');
    trunklidAni.setAttribute('to', '-120 0 0');
    trunklidAni.setAttribute('delay', '0');
    trunklidAni.setAttribute('dur', '1500');
    trunklidAni.setAttribute('fill', 'forwards');
    lid.appendChild(trunklidAni);

    var shadow = document.createElement("a-entity");
    shadow.setAttribute('geometry', 'primitive:plane; width:1.2; height:0.7;');
    shadow.setAttribute('material', 'color:#2d283d; opacity:0.5');
    shadow.setAttribute('rotation', '-90 0 0');
    shadow.setAttribute('position', '0 -0.45 0.3');
    el.appendChild(shadow);

    var coin = document.createElement("a-entity");
    coin.setAttribute('geometry', 'primitive:cylinder; radius:0.175; height:0.05;');
    coin.setAttribute('material', 'color:#fcc137; opacity:1;');
    coin.setAttribute('scale', '0.5 0.5 0.5');
    coin.setAttribute('rotation', '90 0 0');
    coin.setAttribute('position', '0 -0.150 0.3');
    el.appendChild(coin);

    var coinAniPos = document.createElement("a-animation");
    coinAniPos.setAttribute('attribute', 'position');
    coinAniPos.setAttribute('begin', 'reveal');
    coinAniPos.setAttribute('from', '0 -0.150 0.3');
    coinAniPos.setAttribute('to', '0 0.75 0.3');
    coinAniPos.setAttribute('delay', '1800');
    coinAniPos.setAttribute('dur', '500');
    coinAniPos.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniPos);

    var coinAniRot = document.createElement("a-animation");
    coinAniRot.setAttribute('attribute', 'rotation');
    coinAniRot.setAttribute('begin', 'reveal');
    coinAniRot.setAttribute('from', '90 0 0');
    coinAniRot.setAttribute('to', '90 360 0');
    coinAniRot.setAttribute('delay', '1800');
    coinAniRot.setAttribute('dur', '750');
    coinAniRot.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniRot);

    var coinAniScale = document.createElement("a-animation");
    coinAniScale.setAttribute('attribute', 'scale');
    coinAniScale.setAttribute('begin', 'reveal');
    coinAniScale.setAttribute('from', '0.5 0.5 0.5');
    coinAniScale.setAttribute('to', '1 1 1');
    coinAniScale.setAttribute('delay', '1800');
    coinAniScale.setAttribute('dur', '250');
    coinAniScale.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniScale);

    var coinAniAlpha = document.createElement("a-animation");
    coinAniAlpha.setAttribute('attribute', 'material.opacity');
    coinAniAlpha.setAttribute('begin', 'reveal');
    coinAniAlpha.setAttribute('from', '1');
    coinAniAlpha.setAttribute('to', '0');
    coinAniAlpha.setAttribute('delay', '2000');
    coinAniAlpha.setAttribute('dur', '400');
    coinAniAlpha.setAttribute('fill', 'forwards');
    coin.appendChild(coinAniAlpha);

    var trunkclue = document.createElement("a-entity");
    trunkclue.setAttribute('geometry', 'primitive:plane; width:0.75; height:0.36;');
    trunkclue.setAttribute('material', 'color:#fff; transparent:true; src:' + data.clue + '; side:double');
    trunkclue.setAttribute('rotation', '0 0 0');
    trunkclue.setAttribute('position', '0 0.75 0.4');
    trunkclue.setAttribute('scale', '0 0 0');
    el.appendChild(trunkclue);

    var trunkclueAniScale = document.createElement("a-animation");
    trunkclueAniScale.setAttribute('attribute', 'scale');
    trunkclueAniScale.setAttribute('begin', 'reveal');
    trunkclueAniScale.setAttribute('to', '1 1 1');
    trunkclueAniScale.setAttribute('delay', '2500');
    trunkclueAniScale.setAttribute('dur', '500');
    trunkclueAniScale.setAttribute('fill', 'forwards');
    trunkclue.appendChild(trunkclueAniScale);

    var shut = true;

    el.addEventListener(data.on, function (evt) {

      console.log('Trunk was clicked at: ', evt.detail.intersection.point);

      if (shut) {
        lid.emit('reveal');
        coin.emit('reveal');
        trunkclue.emit('reveal');

        opensound.components.sound.stopSound();opensound.components.sound.playSound();
        setTimeout(function () {
          coinsound.components.sound.stopSound();coinsound.components.sound.playSound();
        }, 2500);

        shut = false;
      }

      var clickActionFunctionName = data.clickAction;
      console.log("in trunk, clickActionFunctionName: " + clickActionFunctionName);
      // find object
      var clickActionFunction = window[clickActionFunctionName];
      //console.log("clickActionFunction: "+clickActionFunction);
      // is object a function?
      if (typeof clickActionFunction === "function") clickActionFunction();
    });
  },
  setClickAction: function setClickAction(action) {
    this.data.clickAction = action; //change function dynamically
  },
  play: function play() {},
  update: function update(oldData) {}
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(57);

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global AFRAME THREE */
// A-FrameE
AFRAME.registerShader('custom-shader', {
  schema: {
    dashSize: { default: 3 },
    lineWidth: { default: 1 }
  },
  /**
   * `init` used to initialize material. Called once.
   */
  init: function init(data) {
    this.material = new THREE.LineDashedMaterial(data);
    // `update()` currently not called after `init`. (#1834)
    this.update(data);
  },

  /**
   * `update` used to update the material. Called on initialization and when data updates.
   */
  update: function update(data) {
    this.material.dashsize = data.dashsize;
    this.material.linewidth = data.linewidth;
  }
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import './custom-system'


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(60);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A-Frame
var AFRAME = window.AFRAME;
var extendDeep = AFRAME.utils.extendDeep;
// The mesh mixin provides common material properties for creating mesh-based primitives.
// This makes the material component a default component and maps all the base material properties.
var meshMixin = AFRAME.primitives.getMeshMixin();
AFRAME.registerPrimitive('a-custom-box', extendDeep({}, meshMixin, {
  // Preset default components.
  // These components and component
  // properties will be attached to the entity out-of-the-box.
  defaultComponents: {
    geometry: { primitive: 'box' }
  },
  // Defined mappings from HTML attributes to component properties
  // (using dots as delimiters). If we set `depth="5"` in HTML,
  // then the primitive will automatically set `geometry="depth: 5"`.
  mappings: {
    depth: 'geometry.depth',
    height: 'geometry.height',
    width: 'geometry.width'
  }
}));

/***/ })
/******/ ]));


// WEBPACK FOOTER //
// js/aframe-app.js